import { render, staticRenderFns } from "./emailRecordingHistory.vue?vue&type=template&id=8c6574fc&scoped=true&"
import script from "./emailRecordingHistory.vue?vue&type=script&lang=ts&"
export * from "./emailRecordingHistory.vue?vue&type=script&lang=ts&"
import style1 from "./emailRecordingHistory.vue?vue&type=style&index=1&id=8c6574fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6574fc",
  null
  
)

export default component.exports